import React, { Fragment } from 'react';

const Agreement = ({ order }) => (
    <Fragment>
        <h6 className="text-muted text-uppercase">Assinatura</h6>
        <p>Declaro que li e estou de acordo com o Termo.</p>
        <hr className="b-1 border-dark my-0" />
        <p>{order.customer.name}</p>
    </Fragment>
);

export default Agreement


// WEBPACK FOOTER //
// ./src/components/Pages/Receipt/Agreement.js